import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../packingList/packing.scss";
import "react-datepicker/dist/react-datepicker.css";
import { NotFound } from "../../components/common/NotFound";
import DeleteModal from "../../components/common/DeleteModal";

const PackingList = () => {
  const [baseColumns] = useState([
    {
      heading: "Customer Name",
      value: "CustomerName",
      sortable: true,
      title: "CustomerName",
      dataIndex: "CustomerName",
      key: "CustomerName",
    },
    {
      heading: "Email",
      value: "Email",
      sortable: true,
      title: "Email",
      dataIndex: "Email",
      key: "Email",
    },
    {
      heading: "Assigned Engineer",
      value: "AssignedEngineer",
      sortable: true,
      title: "AssignedEngineer",
      dataIndex: "AssignedEngineer",
      key: "AssignedEngineer",
    },
    {
      heading: "Credit Limit",
      value: "Creditlimit",
      sortable: true,
      title: "Creditlimit",
      dataIndex: "Creditlimit",
      key: "Creditlimit",
    },
    {
      heading: "Country",
      value: "Country",
      sortable: true,
      title: "Country",
      dataIndex: "Country",
      key: "Country",
    },
    {
      heading: "Status",
      value: "status",
      sortable: true,
      title: "status",
      dataIndex: "status",
      key: "status",
    },
  ]);

  const [selected, setSelected] = useState([]);

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == true) {
      setSelected((oldData) => [...oldData, e.target.value]);
      // let value = baseColumns.filter((item) => !selected.includes(item.dataIndex))
      // setFilterColumn(value);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };
  return (
    <div className="container-fluid packing-list-sec">
      {/* <!-- search-area-sec starts --> */}
      <div className="card mt-3">
        <div className="card-body">
          <section className="search-area-sec">
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12">
                <div className="mob-text-align">
                  <p>
                    Products - <span>100 Results Found</span>
                  </p>
                </div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div className="input-group text-align">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <div className="input-group-append">
                    <button className="btn" type="button">
                      <i className="fas fa-times"></i>
                    </button>
                    <button className="btn" type="button">
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-12 col-xs-12">
                <div class="dropdown text-align mob-mt-13">
                  <button
                    className="btn hambeger-btn"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fas fa-bars"></i>
                  </button>

                  <div
                    class="dropdown-menu p-3"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {baseColumns.map((data, index) => (
                      <div class="custom-control custom-switch pb-2 ">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id={`${index}`}
                          value={data.title}
                          onChange={(e) => handleChange(e, index)}
                        />
                        <label class="custom-control-label" for={`${index}`}>
                          {data.title}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-12 col-xs-12">
                <div className="text-align mob-mt-13">
                  <button
                    className="btn filter-btn"
                    type="button"
                    data-toggle="modal"
                    data-target="#filterRightSideModalPopup"
                  >
                    <span className="float-left">
                      <i className="fas fa-filter"></i>
                    </span>
                    <span className="float-right mt-1">Filter</span>
                  </button>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- search-area-sec ends --> */}
          {/* <!-- table-sec starts --> */}

          <section className="table-sec mt-3">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div>
                  <table className="table table-striped table-borderless">
                    <thead>
                      <tr>
                        <th scope="col">Division</th>
                        <th scope="col">Factory Order</th>
                        <th scope="col" className="sort-icon">
                          LPO Reference
                        </th>
                        <th scope="col" className="sort-icon">
                          Customer
                        </th>
                        <th scope="col" className="sort-icon">
                          Packed Date
                        </th>
                        <th scope="col">DN Number</th>
                        <th scope="col">Invoice Number</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Jersey Mef</td>
                        <td>KMC/FO/2316485-22</td>
                        <td>DDAB/PO 1325-VER-2</td>
                        <td>Metrix Qatar W.L.L</td>
                        <td>12-12-2022</td>
                        <td>-</td>
                        <td>12-12-2022</td>
                        <td>
                          <span>
                            <i className="far fa-eye" title="View"></i>
                          </span>
                          <span>
                            <i
                              className="far fa-trash-alt"
                              data-toggle="modal"
                              data-target="#deleteModal"
                              title="Delete"
                            ></i>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Jersey Mef</td>
                        <td>KMC/FO/2316485-22</td>
                        <td>DDAB/PO 1325-VER-2</td>
                        <td>Metrix Qatar W.L.L</td>
                        <td>12-12-2022</td>
                        <td>-</td>
                        <td>12-12-2022</td>
                        <td>
                          <span>
                            <i className="far fa-eye" title="View"></i>
                          </span>
                          <span>
                            <i
                              className="far fa-trash-alt"
                              data-toggle="modal"
                              data-target="#deleteModal"
                              title="Delete"
                            ></i>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Jersey Mef</td>
                        <td>KMC/FO/2316485-22</td>
                        <td>DDAB/PO 1325-VER-2</td>
                        <td>Metrix Qatar W.L.L</td>
                        <td>12-12-2022</td>
                        <td>-</td>
                        <td>12-12-2022</td>
                        <td>
                          <span>
                            <i className="far fa-eye" title="View"></i>
                          </span>
                          <span>
                            <i
                              className="far fa-trash-alt"
                              data-toggle="modal"
                              data-target="#deleteModal"
                              title="Delete"
                            ></i>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- table-sec ends --> */}

          {/* pagination-sec */}
          <section className="pagination-sec">
            <div className="row">
              <div className="col-md-12">
                <div className="pagination-d-flex">
                  <div className="d-flex justify-content-end align-items-baseline">
                    <p className="mr-2">Show</p>
                    <select className="form-control">
                      <option selected value="10">
                        1
                      </option>
                      <option value="2">2</option>
                    </select>
                  </div>
                  <nav aria-label="Page navigation example" className="ml-4">
                    <ul className="pagination">
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link active" href="#">
                          1
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          2
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          3
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* // <!-- filter modal start--> */}

      {/* <!-- deleteModal start--> */}
      <DeleteModal />

      {/*  <!-- NotFound--> */}
      <NotFound />
    </div>
  );
};

export default PackingList;
